import * as React from "react"

type Props = {
  children: React.ReactNode
  color?: string
  fontSize?: string
  roundedSize?: string
  fontBold?: boolean
  disabled?: boolean
  classes?: string
  onClick?: React.MouseEventHandler | undefined
}

const ButtonOutline: React.FC<Props> = ({
  children,
  color = "blue-800",
  fontSize = "base",
  roundedSize = "full",
  fontBold = true,
  classes = "",
  onClick,
}) => (
  <button
    type="button"
    className={
      "bg-white border border-solid shadow focus:outline-none" +
      " " +
      [
        `text-${color}`,
        `rounded-${roundedSize}`,
        `border-${color}`,
        `text-${fontSize}`,
        ...(fontBold ? ["font-bold"] : []),
      ].join(" ") +
      " " +
      classes
    }
    onClick={onClick}
  >
    {children}
  </button>
)

export default ButtonOutline
